import { render, staticRenderFns } from "./start-guide.vue?vue&type=template&id=f8c1e842"
import script from "./start-guide.vue?vue&type=script&lang=js"
export * from "./start-guide.vue?vue&type=script&lang=js"
import style0 from "./start-guide.vue?vue&type=style&index=0&id=f8c1e842&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports